<template>
    <div>
        <template v-if="viewPage === true && feeVoucher !== null">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Fee  Voucher Detail </h1>
            </div>
            <div class="vendor-profile-box mb-3">
                <div class="row mb-4">
                    <div class="col">
                        <div class="vendor-profile-head clearfix">
                            <h2> {{feeVoucher.student.name}} </h2>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Student ID </span>
                        <p class="value-text"> {{feeVoucher.student.student_id}} </p>
                    </div>
                    <div class="col">
                        <span class="label block-label"> Campus </span>
                        <p class="value-text"> {{feeVoucher.student.campus.name}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Invoice No. </span>
                        <p class="value-text"> {{feeVoucher.invoice_no}} </p>
                    </div>
                    <div class="col">
                        <span class="label block-label"> Admission Fee </span>
                        <p class="value-text"> {{feeVoucher.admission_fee}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Registration Fee </span>
                        <p class="value-text"> {{feeVoucher.registration_fee}} </p>
                    </div>
                    <div class="col">
                        <span class="label block-label"> Tuition Fee </span>
                        <p class="value-text"> {{feeVoucher.tuition_fee}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Security Charges </span>
                        <p class="value-text"> {{feeVoucher.security_charges}} </p>
                    </div>
                    <div class="col">
                        <span class="label block-label"> Head Office Charges </span>
                        <p class="value-text"> {{feeVoucher.head_office_charges}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Annual Fund </span>
                        <p class="value-text"> {{feeVoucher.annual_fund}} </p>
                    </div>
                    <div class="col">
                        <span class="label block-label"> Examination Charges </span>
                        <p class="value-text"> {{feeVoucher.examination_charges}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Transportation Charges </span>
                        <p class="value-text"> {{feeVoucher.transportation_charges}} </p>
                    </div>
                    <div class="col">
                        <span class="label block-label"> Rent </span>
                        <p class="value-text"> {{feeVoucher.rent}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Fine </span>
                        <p class="value-text"> {{feeVoucher.fine}} </p>
                    </div>
                    <div class="col">
                        <span class="label block-label"> Others </span>
                        <p class="value-text"> {{feeVoucher.others}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <span class="label block-label"> Challan No. </span>
                        <p class="value-text"> {{feeVoucher.unique_identifier}} </p>
                    </div>
                    <div class="col">
                        <span class="label block-label"> Due Date </span>
                        <p class="value-text"> {{feeVoucher.invoice_due_date}} </p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-6">
                        <span class="label block-label"> Grand Total </span>
                        <p class="value-text"> {{feeVoucher.invoice_amount}} </p>
                    </div>
                    <div class="col-3">
                        <span class="label block-label"> Status </span>
                        <p class="value-text"> {{feeVoucher.status}} </p>
                    </div>
                    <div class="col-3">
                        <span class="label block-label"> Download Voucher </span>
                        <div class="value-text">
                            <a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" title="Download" class="action" @click="downloadVoucher(feeVoucher.id)"><i class="fas fa-download"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <h3 class="vendor-profile-heading mb-3"> Payments </h3>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="complete-profile" role="tabpanel" aria-labelledby="complete-profile-tab">
                    <table id="paymentDetail" class="table table-responsive-xl" style="width:100%">
                        <thead>
                        <tr>
                            <th>No.</th>
                            <th>Transaction Number</th>
                            <th>Date</th>
                            <th>Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(payment, index) in feeVoucherPayments">
                            <td> {{index + 1}} </td>
                            <td>{{payment.transaction_number}}</td>
                            <td>{{payment.transaction_date}}</td>
                            <td>{{payment.amount}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
        <template v-else-if="viewPage === null && feeVoucher === null">
            <div class="inside-loader">
                <div class="inside-loader-inner">
                    <img src="/images/payroll.png" alt="" />
                    <i class="fas fa-circle-notch fa-spin"></i>
                </div>
            </div>
        </template>
        <template v-else-if="viewPage === false">
            <notAllowed></notAllowed>
        </template>

    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
                viewPage : null,
                feeVoucher : null,
                feeVoucherPayments : null
            };
        },
        mounted() {
            gThat = this;
            this.$Progress.start();
            this.getFeeVoucherDetailData();
            this.$Progress.finish();
        },
        methods: {
            getFeeVoucherDetailData : function () {
                axios.get('/api/feeVoucherDetail/'+this.$route.params.id)
                    .then(res => {
                        if(res.status == 200){
                            this.viewPage = res.data.viewPage;
                            this.feeVoucher = res.data.feeVoucher;
                            this.feeVoucherPayments = res.data.feeVoucherPayments;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load fee  voucher detail');
                        }
                    })
                    .then(res =>{
                        var feeVoucherPaymentsTable = $('#paymentDetail').DataTable({
                            "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                            deferRender: true,
                        });
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load fee  vouhcer detail');
                    });
            },
            downloadVoucher: function(id){

                gThat.$Progress.start();
                toast.fire({ type: 'success', title: 'Processing ...'});

                axios.get('/api/feeVoucherDownload/'+id, {responseType: 'arraybuffer'})
                .then((response) => {
                    if(response.status == 200)
                    {
                        let blob = new Blob([response.data], { type: 'application/pdf' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Fee-Voucher-' + moment().format('YYYYMMDDHHmmss') + '-' + id + '.pdf';
                        link.click();
                        toast.fire({
                            type: 'success',
                            title: 'File Downloaded Successfully'
                        });

                        gThat.$Progress.finish();
                    }
                    else
                    {
                        gThat.showAlertBox('error','There is some problem');
                    }
                }).catch(err => {
                    gThat.showAlertBox('error','There is some problem');
                });
            },
        },
        created() {
            //
        }
    }
</script>
